import React from 'react';
import Logo from 'components/atoms/Logo';
import { LOGO_ALT_TEXT } from 'constants/logo.constants';
import { SignUpLayoutProps } from 'types/organisms.types';

const SignUpLayout: React.FC<SignUpLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4 sm:px-6 lg:px-8 gradient-bg">
      <div className="max-w-md w-full space-y-8 gradient-content">
        {/* Header Section */}
        <div className="text-center">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <Logo 
              variant="full" 
              size="lg"
              alt={LOGO_ALT_TEXT.FULL}
            />
          </div>
          
          {/* Subtitle */}
          <p className="mb-8" style={{
            fontFamily: 'Satoshi',
            fontWeight: 700,
            fontSize: '30px',
            lineHeight: '120%',
            letterSpacing: '0%',
            textAlign: 'center'
          }}>
            Fast, accurate classification and<br />
            compliance for U.S. imports
          </p>
        </div>

        {/* Content Card */}
        <div className="bg-white rounded-lg shadow-md p-8">
          <div className="text-center mb-6">
            <h2 className="mb-2" style={{
              fontFamily: 'Satoshi',
              fontWeight: 700,
              fontSize: '30px',
              lineHeight: '120%',
              letterSpacing: '0%',
              textAlign: 'center'
            }}>
              Create your free Classifi account today!
            </h2>
            <p style={{
              fontFamily: 'Satoshi',
              fontWeight: 400,
              fontSize: '12px',
              lineHeight: '130%',
              letterSpacing: '0%',
              textAlign: 'center'
            }}>
              No credit card required. 100% secure. Get HTS codes, duty<br />
              rates, tariffs, and regulatory flags. Work smarter with Classifi.
            </p>
          </div>
          
          {children}
        </div>
      </div>
    </div>
  );
};

export default SignUpLayout;
